import React, {Component} from 'react';
import './MapAdditionalButtons.scss';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';

export default class MapAdditionalButtons extends Component {
    constructor(props) {
        super(props);
    }

    onFitBoundsClick() {
        if (this.props.onFitBoundsClick)
            this.props.onFitBoundsClick();
    }

    render() {
        return (
            <div>
                <div className="map-additional-buttons">
                    <div className="map-additional-button"
                         onClick={this.onFitBoundsClick.bind(this)}>
                        <CenterFocusStrongIcon/>
                    </div>
                </div>
            </div>
        )
    }
}